import { CONDITIONS } from '@src/constants/health-record/conditions'
import { SYMPTOM_CHEAKER } from '@src/constants/health-record/symptom_cheaker'
import { SYMPTOMS } from '@src/constants/health-record/symptoms'
import { SURGERIES } from '@src/constants/health-record/surgeries'
import { PROCEDURES } from '@src/constants/health-record/procedures'
import { MEDICATIONS } from '@src/constants/health-record/medications'
import { SUPPLEMENTS } from '@src/constants/health-record/supplements'
import { IMMUNIZATIONS } from '@src/constants/health-record/immunizations'
import { ALLERGIES } from '@src/constants/health-record/allergies'
import { FAMILY_HISTORY } from '@src/constants/health-record/family_history'
import { SOCIAL_HISTORY } from '@src/constants/health-record/social_history'
import { MEDICAL_VISITS } from '@src/constants/health-record/medical_visits'
import { LABS } from '@src/constants/health-record/labs'
import { DIAGNOSTICS } from '@src/constants/health-record/diagnostics'
import { TRAVEL_HISTORY } from '@src/constants/health-record/travel_history'
export const hrGroups = {
  MEDICAL_HISTORY: 1,
  MEDICATIONS: 2,
  DIAGNOSTICS: 3,
  ALLERGIES: 4,
  VISITS: 5,
}

export const healthRecord = {
  SYMPTOM_CHEAKER,
  CONDITIONS,
  SYMPTOMS,
  SURGERIES,
  PROCEDURES,
  DIAGNOSTICS,
  LABS,
  IMMUNIZATIONS,
  FAMILY_HISTORY,
  MEDICATIONS,
  SUPPLEMENTS,
  ALLERGIES,
  SOCIAL_HISTORY,
  MEDICAL_VISITS,
  TRAVEL_HISTORY,
  // IMAGINGS,
  // BIOMETRICS,
}

export const healthRecordAddModel = {
  // SYMPTOM_CHEAKER,
  ALLERGIES,
  LABS,
  SUPPLEMENTS,
  FAMILY_HISTORY,
  CONDITIONS,
  SURGERIES,
  MEDICAL_VISITS,
  MEDICATIONS,
  SYMPTOMS,
  DIAGNOSTICS,
  PROCEDURES,
  TRAVEL_HISTORY,
  IMMUNIZATIONS,
  SOCIAL_HISTORY,
}

export const healthRecordModels = {
  symptomcheaker: 'SYMPTOM_CHEAKER',
  condition: 'CONDITIONS',
  symptom: 'SYMPTOMS',
  surgery: 'SURGERIES',
  procedure: 'PROCEDURES',
  medication: 'MEDICATIONS',
  supplement: 'SUPPLEMENTS',
  immunization: 'IMMUNIZATIONS',
  allergy: 'ALLERGIES',
  familyhistory: 'FAMILY_HISTORY',
  socialhistory: 'SOCIAL_HISTORY',
  medicalvisit: 'MEDICAL_VISITS',
  lab: 'LABS',
  diagnostic: 'DIAGNOSTICS',
  imaging: 'IMAGINGS',
  travelhistory: 'TRAVEL_HISTORY',
  // biometric: 'BIOMETRICS',
}
